import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import DaTable from './DaTable'
import DaTable3 from './v3/DaTable'
import {AREA} from './../../index'

export default class Resource extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            limit: props.data.limit ? props.data.limit : 50,
            offset: props.data.offset ? props.data.offset : 0,
            userfilter: props.data.userfilter ? props.data.userfilter : [],
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            metadata: props.data.metadata,
            url: props.data.url,
            params: props.data.params ? props.data.params : {}
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        this.setState({loading: true});
        const params = this.state.params;
        const filter = this.state.filter;
        params.filter = [];        
        if (filter !== undefined) {
            params.filter = filter;
        }
        params.pagination = {page: this.state.offset/this.state.limit+1, perPage: this.state.limit }
        this.props.childProps.dataProvider.getList(this.state.url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    this.setState({
                        datarows: response.data.data,
                        servermeta: response.data.metadata,
                        datalen: response.data.data.length,
                        loading: false
                    })
                } else {
                    toast.error("Something went wrong... backend not reachable. Try to reload page", {})
                }
            }
        );
    }
    onLoadMore() {
        var offset = this.state.offset + this.state.limit;
        this.setState({
                offset: offset
            }, function () {
                this.loadFromServer()
            }
        );
    }
    onFilter(filter) {
        this.setState({
                offset: 0,
                filter:  filter.toJS()
            }, function () {
                this.loadFromServer()
            }
        );
    }
    render() {
        var data = {
            data: this.state.datarows,
            metadata: this.state.servermeta
        };
        if (AREA === "admin") {
            return (
                <DaTable3
                    data={data}
                    metadata={this.state.metadata}
                    userfilter = {this.state.userfilter}
                    onFilter = { this.onFilter.bind(this) }
                    url={this.state.url}
                    urlattrs={this.props.urlattrs}
                    onLoadMore = { this.onLoadMore.bind(this) }
                    datalen = { this.state.datalen }
                    limit = { this.state.limit }
                    offset = { this.state.offset }
                    loading = { this.state.loading }
                    childProps={this.props.childProps}
                    download
                />
            )
        }
        return (
            <DaTable
                data={data}
                metadata={this.state.metadata}
                userfilter = {this.state.userfilter}
                onFilter = { this.onFilter.bind(this) }
                url={this.state.url}
                urlattrs={this.props.urlattrs}
                onLoadMore = { this.onLoadMore.bind(this) }
                datalen = { this.state.datalen }
                limit = { this.state.limit }
                offset = { this.state.offset }
                loading = { this.state.loading }
                childProps={this.props.childProps}
                download
            />
        )
    }
}
